import Alert from '@amzn/meridian/alert';
import Link from '@amzn/meridian/link';
import Text from '@amzn/meridian/text';
import Toaster from '@amzn/meridian/toaster';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import DataSource from '../../../api';
import { StateContext } from '../../../GlobalStateStore';
import DataState from '../../../Types/DataState';
import {
  ProxyNotification,
  ProxyNotificationType,
} from '../../../Types/ProxyNotification';
import { renderUrl, urls } from '../../../config/Url';

interface TeamProxyNotificationProps {
  navigateTo: any;
}

const TeamProxyNotification: React.FC<TeamProxyNotificationProps> = ({
  navigateTo,
}): React.ReactElement => {
  const globalState = useContext(StateContext);
  const apiNaws = DataSource.getDataFeed('NAWS');
  const proxyNotificationToast = [
    {
      id: 'cs_perfportal_proxy_notification_toast',
    },
  ];
  const [proxyNotificationList, setProxyNotificationList] = useState<
    ProxyNotification[]
  >([]);
  const [proxyNotificationState, setProxyNotificationState] = useState(
    DataState.LOADING
  );
  const [deleteProxyNotificationState, setDeleteProxyNotificationState] =
    useState('');
  const [showProxyNotification, setShowProxyNotification] = useState(false);
  const [proxyNotificationUserNames, setProxyNotificationUserNames] =
    useState('');
  const [proxyNotificationSwitchUrl, setProxyNotificationSwitchUrl] =
    useState('');

  useEffect(() => {
    const { userID, cscEntityPrefix } = globalState.state.inspireOptions.data;
    if (userID) {
      const queryVariables = apiNaws.prepareQueryForGetProxyNotification(
        userID,
        cscEntityPrefix
      );
      apiNaws.getProxyNotification(
        queryVariables,
        setProxyNotificationList,
        setProxyNotificationState
      );
    }
  }, [globalState.state.inspireOptions.data]);

  useEffect(() => {
    if (proxyNotificationState === DataState.LOADED) {
      const notifications = filterProxyNotification(
        proxyNotificationList,
        ProxyNotificationType.CREATE_PROXY
      );
      if (notifications.length > 0) {
        setShowProxyNotification(true);
        if (notifications.length === 1) {
          setProxyNotificationUserNames(notifications[0].relatedUsername);
        } else {
          setProxyNotificationUserNames(
            '[' +
              notifications
                .map(notification => notification.relatedUsername)
                .join(', ') +
              ']'
          );
        }
      }
    }
  }, [proxyNotificationState]);

  useEffect(() => {
    if (deleteProxyNotificationState === DataState.LOADED) {
      setShowProxyNotification(false);
      if (proxyNotificationSwitchUrl !== '') {
        navigateTo(proxyNotificationSwitchUrl);
      }
    }
  }, [deleteProxyNotificationState]);

  const onCloseProxyNotification = useCallback(
    (href: any) => {
      const { userID, cscEntityPrefix } = globalState.state.inspireOptions.data;
      if (userID && proxyNotificationState === DataState.LOADED) {
        const queryVariables = apiNaws.prepareQueryForDeleteProxyNotification(
          userID,
          cscEntityPrefix,
          filterProxyNotification(
            proxyNotificationList,
            ProxyNotificationType.CREATE_PROXY
          )
        );
        apiNaws.deleteProxyNotification(
          queryVariables,
          (deleteNotifResult: string) => deleteNotifResult, // do nothing
          setDeleteProxyNotificationState
        );
        if (href) {
          setProxyNotificationSwitchUrl(href);
        }
      }
    },
    [globalState.state.inspireOptions.data, proxyNotificationState]
  );

  const filterProxyNotification = (
    proxyNotifications: ProxyNotification[],
    type: ProxyNotificationType
  ): ProxyNotification[] => {
    const filteredNotification: ProxyNotification[] = [];
    // eslint-disable-next-line array-callback-return
    proxyNotifications.map((notification: ProxyNotification) => {
      if (notification.type === type) {
        filteredNotification.push(notification);
      }
    });
    return filteredNotification;
  };

  return (
    <>
      {showProxyNotification && (
        <Toaster
          toasts={proxyNotificationToast}
          onCloseToast={onCloseProxyNotification}
          alignmentHorizontal='center'
        >
          {(): React.ReactElement => (
            <Alert
              type='neutral'
              toast={true}
              onClose={onCloseProxyNotification}
            >
              <Text>
                <div>
                  {proxyNotificationUserNames}{' '}
                  <FormattedMessage
                    id='cs_perfportal_proxy_notification_message'
                    defaultMessage='shared their team with you. Coach using the'
                  />{' '}
                  <Link
                    type='secondary'
                    href={renderUrl(urls.proxy)}
                    onClick={onCloseProxyNotification}
                    data-csa-c-type='link'
                    data-csa-c-slot-id='open-proxy-team-tab-notification-slot'
                    data-csa-c-content-id='open-proxy-team-tab-notification'
                    data-csa-c-description='Navigate to proxy tab from notification link'
                    data-csa-c-tag1='Proxy_Team'
                  >
                    <FormattedMessage
                      id='cs_perfportal_proxy_notification_link_proxy_tab'
                      defaultMessage='Proxy tab.'
                    />
                  </Link>
                </div>
              </Text>
            </Alert>
          )}
        </Toaster>
      )}
    </>
  );
};

export default TeamProxyNotification;
